function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SessionStorage from 'libs/SessionStorage';
import { AppContext } from 'context';
import FormContainerAbstract from 'components/FormContainerAbstract';
import Form from 'components/Form';
import Button from 'components/Form/Button';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import CheckboxRadio from 'components/Form/CheckboxRadio';
import Link from 'components/Link';
import App from 'modules/App';
import * as actions from '../../../actions';
import * as constants from '../../../constants';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
import validatorRules from './validatorRules.json';
class Credentials extends FormContainerAbstract {
    static getDerivedStateFromProps(props, state) {
        const { isInProgress, hasErrors } = props;
        if (isInProgress && !state.isInProgress) {
            return {
                isInProgress: true
            };
        }
        if (hasErrors && state.isInProgress) {
            return {
                isInProgress: false
            };
        }
        return null;
    }
    get signUpUrl() {
        const { returnUrl } = this.props;
        if (!returnUrl) return this.context.getUrl('sign-up');
        return this.props.isIntegrationProcess ? `${this.context.getUrl('sign-up')}?ReturnUrl=${encodeURIComponent(returnUrl)}` : this.context.getUrl('sign-up');
    }
    get resetPasswordUrl() {
        const { returnUrl } = this.props;
        if (!returnUrl) return this.context.getUrl('reset-password');
        return this.props.isIntegrationProcess ? `${this.context.getUrl('reset-password')}?ReturnUrl=${encodeURIComponent(returnUrl)}` : this.context.getUrl('reset-password');
    }
    componentDidMount() {
        if (!this.props.returnUrl) {
            this.props.onInit();
        }
        if (this.props.isTrustedClientFlow) {
            this.onSetValue({
                id: 'rememberMe',
                value: true
            });
        }
    }
    onSetBlsReturnUrl() {
        const url = new URL(this.props.returnUrl);
        const blsReturnUrl = url.searchParams.get('redirect_uri');
        SessionStorage.setItem('blsReturnUrl', blsReturnUrl);
    }
    onSubmit() {
        this.props.onFormProcessing();
        const { validatedValues, errors } = this.onValidate(this.validatorRules);
        this.props.onFormErrors(errors);
        if (!errors) {
            const { returnUrl } = this.props;
            this.props.onSubmit(_object_spread_props(_object_spread({}, validatedValues), {
                returnUrl
            }));
        }
    }
    renderSignUp() {
        if (!this.props.allowSignUp) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("p", {
            className: "text-align--center text--normal mt-6",
            children: [
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.noAccount)),
                /*#__PURE__*/ _jsx(Link, {
                    to: this.signUpUrl,
                    className: "text--primary ml-3",
                    onClick: ()=>this.onSetBlsReturnUrl(),
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.signUp))
                })
            ]
        });
    }
    renderActions() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "mt-8",
            children: [
                /*#__PURE__*/ _jsx(Button, {
                    type: "submit",
                    styleModifier: "primary",
                    labelMessage: messages.buttons.signIn,
                    className: "btn--block btn--filled",
                    isDisabled: this.props.isDisabled || this.isDisabled,
                    isInProgress: this.state.isInProgress
                }),
                this.renderSignUp()
            ]
        });
    }
    renderResetPasswordLink() {
        return /*#__PURE__*/ _jsx(Link, {
            to: this.resetPasswordUrl,
            className: "d-block mt-2 mt-sm-0 text--primary",
            onClick: ()=>this.onSetBlsReturnUrl(),
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.resetPassword))
        });
    }
    renderRememberMe() {
        if (!this.props.allowSignUp) {
            return null;
        }
        if (this.props.isTrustedClientFlow) {
            return /*#__PURE__*/ _jsx("div", {
                className: "d-flex justify-content-end",
                children: this.renderResetPasswordLink()
            });
        }
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: "rememberMe",
            className: "form-group--no-border",
            labelMessage: "",
            actionElement: this.renderResetPasswordLink(),
            formValues: this.props.formValues,
            children: /*#__PURE__*/ _jsx(CheckboxRadio, {
                inputValue: "true",
                labelMessage: messages.labels.rememberMe,
                attributes: {
                    tabIndex: 3
                },
                onChange: (input)=>this.onSetValue(input)
            })
        });
    }
    renderForm() {
        return /*#__PURE__*/ _jsxs(Form, {
            onSubmit: ()=>this.onSubmit(),
            children: [
                /*#__PURE__*/ _jsx(FormGroup, {
                    id: "email",
                    labelMessage: messages.labels.email,
                    formValues: this.props.formValues,
                    children: /*#__PURE__*/ _jsx(Input, {
                        placeholder: messages.placeholders.email,
                        attributes: {
                            tabIndex: 1,
                            autoFocus: true
                        },
                        onChange: (input)=>this.onSetValue(input)
                    })
                }),
                /*#__PURE__*/ _jsx(FormGroup, {
                    id: "password",
                    labelMessage: messages.labels.password,
                    formValues: this.props.formValues,
                    children: /*#__PURE__*/ _jsx(Input, {
                        type: "password",
                        placeholder: messages.placeholders.password,
                        attributes: {
                            tabIndex: 2
                        },
                        onChange: (input)=>this.onSetValue(input)
                    })
                }),
                this.renderRememberMe(),
                this.renderActions()
            ]
        });
    }
    render() {
        if (!this.props.returnUrl) {
            return null;
        }
        return this.renderForm();
    }
    constructor(props){
        super(props);
        this.state = {
            mode: constants.SCOPE_NAMES.PERSONAL,
            isInProgress: false
        };
        this.validatorRules = validatorRules;
    }
}
_define_property(Credentials, "contextType", AppContext);
_define_property(Credentials, "propTypes", _object_spread_props(_object_spread({}, FormContainerAbstract.propTypes), {
    // Explicit props
    returnUrl: PropTypes.string,
    // Explicit actions
    onSetFormValue: PropTypes.func,
    // Implicit props
    isDisabled: PropTypes.bool,
    allowSignUp: PropTypes.bool,
    isIntegrationProcess: PropTypes.bool,
    // Implicit actions
    onInit: PropTypes.func
}));
const mapStateToProps = (state)=>({
        isIntegrationProcess: App.selectors.isIntegrationProcess(state),
        isTrustedClientFlow: App.selectors.isTrustedClientFlow(state),
        allowSignUp: App.selectors.allowSignUp(state),
        identityProviders: selectors.identityProviders(state),
        isDisabled: selectors.isSetInvitationInProgress(state),
        isInProgress: selectors.isSignInInProgress(state),
        hasErrors: selectors.hasSignInErrors(state),
        formValues: App.selectors.formSelector(constants.SIGN_IN_FORM)(state)
    });
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.SIGN_IN_FORM;
    return {
        onInit: ()=>dispatch(actions.initAuth()),
        onSubmit: (values)=>dispatch(actions.signIn(values)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName)),
        onClearForm: ()=>dispatch(App.actions.clearForm(formName))
    };
};
const ConnectedCredentials = connect(mapStateToProps, mapDispatchToProps)(Credentials);
export default ConnectedCredentials;
